import { RestResource } from "./common"
import { ADDRESS_DESER, Address } from "./customer"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"
import type { DateISOString } from "./util/date-iso-string"

export class EntityBeneficialOwner extends RestResource {
  static onInitialize = (_obj: EntityBeneficialOwner) => {
    /* no-op */
  }

  constructor() {
    super()
    EntityBeneficialOwner.onInitialize(this)
  }

  firstName = ""
  middleName = ""
  lastName = ""
  birthDate: DateISOString | null = null
  email = ""
  taxNumber = ""
  ownershipPercent = 0
  address: Address = new Address()
}

export const ENTITY_BENEFICIAL_OWNER_DESER: SchemaDeSer<EntityBeneficialOwner> =
  new SchemaDeSerBuilder(EntityBeneficialOwner)
    .ofString("firstName")
    .ofString("middleName")
    .ofString("lastName")
    .ofString("birthDate")
    .ofString("email")
    .ofString("taxNumber")
    .ofFloat("ownershipPercent")
    .ofNested("address", ADDRESS_DESER, Address)
    .ofString("id")
    .toDeSer()
